import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';

const NewPanApplicationCompleteReport = () => {
    const [panData, setPanData] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {
        const fetchPanData = async () => {
            try {
                // Retrieve token from localStorage or sessionStorage
                const authToken = localStorage.getItem("authToken"); // or sessionStorage.getItem('token')

                const response = await fetch(`${API_BASE_URL}/NewPanApplication/GetNewPanRecords`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${authToken}`, // Attach token in the request                       
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                let data = await response.json();

                // Add SrNo property to each record
                data = data.map((record, index) => ({
                    ...record,
                    SrNo: index + 1 // Auto-incrementing SrNo
                }));

                setPanData(data); // Update state with modified data
            } catch (error) {
                console.error('Failed to fetch pan records:', error);
            }
        };

        fetchPanData();
    }, []);


    // Function to update status
    const handleStatusChange = async (registrationNo, newStatus) => {
        const comment = prompt("Enter comment for this status change:");
        if (!comment) return; // Optional: require comment

        try {
            const authToken = localStorage.getItem("authToken");

            const response = await fetch(`${API_BASE_URL}/NewPanApplication/updateStatus/${registrationNo}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({ status: newStatus, comment }),
            });

            if (!response.ok) throw new Error("Failed to update status");

            // Update state only after successful API call
            setPanData(prev =>
                prev.map(row =>
                    row.registrationNo === registrationNo
                        ? { ...row, status: newStatus, comment }
                        : row
                )
            );
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    console.log(panData);

    const successRejectData = panData.filter(r => r.status === "Complete" || r.status === "Rejected" || r.status === "Refunded");

    useEffect(() => {
        if (tableRef.current && successRejectData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true, // Destroy existing table instance
                data: successRejectData,
                columns: [
                    { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
                    { data: 'startDate', title: 'Date' }, // Matches 'startDate'
                    { data: 'name', title: 'Applicant Name' }, // Matches 'name'
                    { data: 'registrationNo', title: 'Registration No' }, // Matches 'registrationNo'
                    {
                        data: 'status',
                        title: 'Status',
                        render: function (data, type, row) {
                            const getStatusColor = (status) => {
                                switch (status) {
                                    case 'In Progress': return '#17a2b8';
                                    case 'Complete': return '#28a745';
                                    case 'Rejected': return '#dc3545';
                                    case 'Refunded': return '#ffc107';
                                    default: return '#6c757d';
                                }
                            };

                            return `
                          <div className="custom-status-dropdown" data-id="${row.registrationNo}">
                            <div class="status-display" style="background-color: ${getStatusColor(data)}; color: ${data === 'In Progress' ? '#000' : '#fff'}; padding: 5px 10px; border-radius: 4px; cursor: pointer; text-align: center; font-weight: bold;">
                              ${data}
                            </div>
                            <select class="form-control status-dropdown" data-id="${row.registrationNo}" style="display: none;">
                              <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                              <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                              <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                              <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                            </select>
                          </div>
                        `;
                        }
                    },
                    { data: 'comment', title: 'Comment' },
                    {
                        data: null,
                        title: "Download Receipt",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download Receipt</button>`;
                        },
                    },
                ]
            });

            // Handle download button click
            $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
                const registrationNo = $(this).data("id");
                downloadReceipt(registrationNo);
            });

            // Handle custom status dropdown click
            $(tableRef.current).on("click", ".status-display", function () {
                const registrationNo = $(this).closest('.custom-status-dropdown').attr("data-id");
                $(this).siblings('.status-dropdown').show().focus();
            });

            // Handle status change
            $(tableRef.current).on("change", ".status-dropdown", function () {
                const registrationNo = $(this).attr("data-id");
                const newStatus = $(this).val();
                const comment = ""; // Or however you get it

                // Update the display
                const statusDisplay = $(this).siblings('.status-display');
                const getStatusColor = (status) => {
                    switch (status) {
                        case 'In Progress': return '#17a2b8';
                        case 'Complete': return '#28a745';
                        case 'Rejected': return '#dc3545';
                        case 'Refunded': return '#ffc107';
                        default: return '#6c757d';
                    }
                };

                statusDisplay.text(newStatus);
                statusDisplay.css({
                    'background-color': getStatusColor(newStatus),
                    'color': newStatus === 'In Progress' ? '#000' : '#fff'
                });

                $(this).hide();
                handleStatusChange(registrationNo, newStatus, comment);
            });

            // Hide dropdown when clicking outside
            $(document).on("click", function (e) {
                if (!$(e.target).closest('.custom-status-dropdown').length) {
                    $('.status-dropdown').hide();
                }
            });

            return () => {
                table.destroy();
            };
        }
    }, [panData]);

    const downloadReceipt = async (registrationNo) => {

        try {
            const response = await fetch(`${API_BASE_URL}/NewPanApplication/download-receipt/${registrationNo}`);
            if (!response.ok) {
                alert("Receipt not available");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `receipt_${registrationNo}.pdf`; // Adjust for different file types
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading receipt:", error);
        }
    };

    // <button onClick={() => downloadReceipt(transactionId)}>Download Receipt</button>


    return (

        <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
        >
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Applicant Name</th>
                    <th>Registration No</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Download Receipt</th>
                </tr>
            </thead>
        </table>

    );
};

export default NewPanApplicationCompleteReport;
